import { render, staticRenderFns } from "./welcomeContact.vue?vue&type=template&id=26fd69fd&"
import script from "./welcomeContact.vue?vue&type=script&lang=js&"
export * from "./welcomeContact.vue?vue&type=script&lang=js&"
import style0 from "./welcomeContact.vue?vue&type=style&index=0&id=26fd69fd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports